import React from 'react';
import { CommandeDef } from 'types/commande/commande.def';
import { IS_PROF } from 'helpers/user/authorization';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { formatDate } from 'helpers/date/formatDate';
import { formatCommandStatus } from 'helpers/commande/formatCommand';
import { firstCharToUpperCase } from 'helpers/text/firstCharToUpperCase';

export interface TableMyResultContentProps {
  variant?: 'default' | 'warning';
  commande: CommandeDef;
  toCommandeSinglePage: () => void;
  toCommandeUpdatePage: () => void;
}

export const MobileTabLineCommandes = ({
  variant = 'default',
  commande,
  toCommandeSinglePage,
  toCommandeUpdatePage
}: TableMyResultContentProps) => {
  return (
    <FeatureContainer key={commande?.id} padding="mobileTab">
      <MobileTabLineBox
        texts={[
          { text: 'N° ' + commande?.numerocommande, style: 'bold' },
          {
            text:
              firstCharToUpperCase(commande?.client.civilite) +
              ' ' +
              commande?.client.nom
          },
          {
            text: formatDate(new Date(commande?.createdAt)),
            style: 'bottomRegular'
          }
        ]}
        variant={
          variant === 'warning'
            ? 'orange'
            : commande.client.affilie
            ? 'grey'
            : 'default'
        }
      />
      <MobileTabLineBox
        title="Total TTC (port inclus + ONG)"
        texts={[
          {
            text: commande?.prixTotal + ' €',
            style: 'bold'
          }
        ]}
        variant={variant === 'warning' ? 'orange' : 'default'}
      />
      <MobileTabLineBox
        title="Client Pro"
        texts={[
          {
            text: commande?.client.clientpro ? 'Oui' : 'Non',
            style: 'bold'
          }
        ]}
        variant={commande?.client.clientpro ? 'green' : 'red'}
      />
      <MobileTabLineBox
        title="Statut de paiement"
        texts={[{ text: formatCommandStatus(commande?.status), style: 'bold' }]}
        variant={commande?.status === 'PAYE' ? 'green' : 'red'}
      />
      <ButtonWithText
        variant="mobileTab"
        onClick={toCommandeSinglePage}
        icon={'MoreAbout'}
        content="Détails"
      />
      {IS_PROF && (
        <ButtonWithText
          variant="mobileTab"
          onClick={toCommandeUpdatePage}
          icon={'Edit'}
          content="Modifier"
        />
      )}
    </FeatureContainer>
  );
};
